export default __webpack_public_path__ + "static/media/fastingdrinks@3x.5a795819.jpg";